import React from 'react';
import ReactDOM from 'react-dom';
import { IScript } from 'interfaces/IScript';
import { BaseComponent } from 'components/BaseComponent';

interface IProps {
  script: IScript;
}

export default class Live extends BaseComponent<{}, IProps> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    const script = document.createElement('script');

    script.innerHTML = `window.__lc = window.__lc || {};
      window.__lc.license = '${this.props.script.value}';
      (function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript'; lc.async = true;
        lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
      })();`;

    ReactDOM.findDOMNode(this).appendChild(script);
  }

  render() {
    return (<div />);
  }
}


// WEBPACK FOOTER //
// ./src/components/Scripts/Live.tsx